export default __webpack_public_path__ + "static/media/237.9733636c.png";